import React, { Fragment } from "react";
import { TableCell, TableRow, makeStyles } from "@material-ui/core";

import MonthColumns from "./MonthColumns";
import theme from "../../../theme";
import { useTranslate } from "react-admin";

const useStyles = makeStyles(() => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    textAlign: "center",
    borderWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
}));

const Head = ({ months }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Fragment>
      <TableRow>
        <TableCell rowSpan="2" classes={classes}>
          {translate("resources.crono.fields.duration")}
        </TableCell>
        <TableCell classes={classes} colSpan={18}>
          {translate("resources.crono.fields.months")}
        </TableCell>
      </TableRow>
      <TableRow>
        <MonthColumns months={months} />
      </TableRow>
    </Fragment>
  );
};
export default Head;
